export default {
  'bankAccounts.searchBar.create': 'Nova Conta Bancária',
  'bankAccounts.filter.order': 'Ordenar por',
  'bankAccounts.filter.order.options.asc': 'Ascendente',
  'bankAccounts.filter.order.options.desc': 'Descendente',
  'bankAccounts.list.header.bank': 'Banco',
  'bankAccounts.list.header.bankCode': 'Código do Banco',
  'bankAccounts.list.header.agency': 'Agência',
  'bankAccounts.list.header.account': 'Conta',
  'bankAccounts.list.header.description': 'Descrição',
  'bankAccounts.list.header.actions': 'Ações',
  'bankAccounts.list.column.actions.details': 'Ver/Editar',
  'bankAccounts.form.bank': 'Banco',
  'bankAccounts.form.status': 'Status',
  'bankAccounts.form.status.active': 'Ativo',
  'bankAccounts.form.status.inactive': 'Inativo',
  'bankAccounts.form.bankCode': 'Código do banco',
  'bankAccounts.form.description': 'Descrição',
  'bankAccounts.form.accountOperation': 'Operação',
  'bankAccounts.form.bankBranch': 'Agência',
  'bankAccounts.form.branchVerificationNumber': 'DV',
  'bankAccounts.form.number': 'Conta',
  'bankAccounts.form.verificationNumber': 'DV',
  'bankAccounts.form.address': 'Endereço',
  'bankAccounts.form.address.zipCode': 'CEP',
  'bankAccounts.form.address.district': 'Bairro',
  'bankAccounts.form.address.uf': 'UF',
  'bankAccounts.form.address.city': 'Cidade',
  'bankAccounts.form.address.street': 'Logradouro',
  'bankAccounts.form.address.number': 'Número',
  'bankAccounts.form.address.complement': 'Complemento',
  'bankAccounts.form.contactList': 'Contatos',
  'bankAccounts.form.contactList.status': 'Status',
  'bankAccounts.form.contactList.status.active': 'Ativo',
  'bankAccounts.form.contactList.status.inactive': 'Inativo',
  'bankAccounts.form.contactList.contactType': 'Tipo de Contato',
  'bankAccounts.form.contactList.contactType.email': 'Email',
  'bankAccounts.form.contactList.contactType.mobile': 'Celular',
  'bankAccounts.form.contactList.contactType.fax': 'Fax',
  'bankAccounts.form.contactList.contactType.phone': 'Telefone',
  'bankAccounts.form.contactList.contactType.whatsapp': 'Whatsapp',
  'bankAccounts.form.contactList.value': 'Valor',
  'bankAccounts.form.contactList.addItem': 'Adicionar Item',
  'bankAccounts.create.notification.success': 'Conta Bancária adicionada!',

  'bankAccounts.status.message.success':
    'Status da Conta Bancária alterada com sucesso!',

  'bankAccounts.create.notification.successDescription':
    'A Conta Bancária foi adicionada com sucesso!',
  'bankAccounts.remove.modal.content':
    'Você tem certeza que deseja remover a Conta Bancária?',

  'bankAccounts.update.notification.success': 'Sucesso',
  'bankAccounts.update.notification.successDescription':
    'Conta bancária atualizada com sucesso!',

  'bankAccounts.remove': 'Remover Conta Bancária',
  'bankAccounts.remove.notification.success': 'Conta bancária removida!',
  'bankAccounts.remove.notification.successDescription':
    'Conta bancária removida com suceso!',
  'bankAccounts.remove.modal.button.ok': 'Remover',

  'bankAccounts.remove.error.delete.constraint':
    'Não é possivel excluir uma Conta Bancária que tenha vínculo com outro módulo!',
};
